import script from "./doctorInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorInfoList.vue?vue&type=script&setup=true&lang=js"

import "./doctorInfoList.vue?vue&type=style&index=0&id=2795a34d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2795a34d"]])

export default __exports__